import React, { useState } from 'react';
import Update from '../Update';
import Media from '../Media';

import {
  Card,
  Stack,
  Fade,
  Divider,
  Checkbox,
  Typography,
  CardHeader,
  CardActionArea,
  useTheme,
  useMediaQuery,
  Chip,
  alpha,
} from '@mui/material';
import { AvatarPopover, CardHeaderTitle, NewSpeedDial } from 'components';
import { FormattedMessage } from 'react-intl';

import { useSelector } from 'react-redux';
import { hasRequiredRole } from 'helpers';
import { fCurrency } from 'helpers/formatNumber';

export default function Model({
  model,
  delay,
  direction,
  isAssign,
  checked,
  handleSelect,
  selectOnClick,
  refetch,
  color,
}) {
  const {
    language: { direction: dir },
  } = useSelector((state) => state.setting);
  const isRtl = dir === 'rtl';
  const { isAuthenticated, userInfo } = useSelector((state) => state.auth);

  const chips = [
    { id: '1', name: 'operationType', title: model?.operation_type?.title },
    { id: '2', name: 'materialType', title: model?.material_type?.title },
    { id: '3', name: 'shiftType', title: model?.shift_type?.title },
    { id: '4', name: 'taskType', title: model?.task_type?.title },
    { id: '5', name: 'workshop', title: model?.workshop?.title },
    { id: '6', name: 'site', title: model?.site?.title },
    { id: '7', name: 'cost', title: fCurrency(model?.cost) },
  ];

  // const workshopTitle = model?.workshop?.title;
  const contractTitle = model?.contract?.title;
  const taskType = model?.task_type?.title;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [updateOpen, setUpdateOpen] = useState(false);
  const canUpdate =
    isAuthenticated &&
    hasRequiredRole(['superadmin', 'companyCeo', 'companyOperator', 'companyFinancial'], userInfo?.roles);
  const handleRowClick = () => (canUpdate && !selectOnClick ? setUpdateOpen(true) : handleSelect());

  return (
    <>
      <Fade in unmountOnExit timeout={{ appear: delay * 100, enter: delay * 120, exit: delay * 140 }}>
        <Card
          sx={{
            position: 'relative',
            // bgcolor: checked && 'action.disabledBackground',
            bgcolor: checked ? 'primary.light' : color ? 'action.disabledOpacity' : 'action.focus',
          }}
        >
          <Stack
            left={8}
            zIndex={1}
            columnGap={0.5}
            height="100%"
            alignItems="center"
            position="absolute"
            justifyContent="flex-start"
            direction={isRtl ? 'row' : 'row-reverse'}
          >
            <Checkbox size="small" checked={checked} onChange={handleSelect} />
            {!isAssign && (
              <Media
                id={model?.id}
                model="Tariff"
                collection="avatar"
                title={model?.title}
                subheader={model?.producer?.title || 'برند'}
              >
                <AvatarPopover media={model?.media[0]?.full_url} />
              </Media>
            )}
          </Stack>
          <Stack
            right={8}
            zIndex={1}
            columnGap={0.5}
            height="100%"
            direction="row"
            alignItems="center"
            position="absolute"
            justifyContent="flex-end"
          >
            <NewSpeedDial>
              {isAuthenticated &&
                hasRequiredRole(
                  ['superadmin', 'companyCeo', 'companyOperator', 'companyFinancial'],
                  userInfo?.roles
                ) && <Update ids={model?.id} title={<FormattedMessage id="update" />} refetch={refetch} />}
              {/* <Media id={model?.id} model="Brand" collection="banner" /> */}
            </NewSpeedDial>
          </Stack>
          <CardActionArea onClick={handleRowClick}>
            <CardHeader
              sx={{ py: 1, px: 0.5, pl: !isAssign ? 13 : 6 }}
              title={<CardHeaderTitle chipWidth={120} titleWidth={200} title={`${taskType}`} chips={chips} />}
              subheader={
                <>
                  {isAuthenticated &&
                    hasRequiredRole(
                      ['superadmin', 'companyCeo', 'companyOperator', 'companyFinancial'],
                      userInfo?.roles
                    ) && (
                      <Stack direction="row" columnGap={1}>
                        <Typography fontSize={11} variant="subtitle2">
                          {model?.contract?.category?.title}
                        </Typography>
                        -
                        <Typography fontSize={11} variant="caption">
                          {model?.contract?.title}
                        </Typography>
                      </Stack>
                    )}
                </>
              }
            />
          </CardActionArea>
        </Card>
      </Fade>
      {updateOpen && (
        <Update
          open
          ids={model.id}
          refetch={refetch}
          title={<FormattedMessage id="update" />}
          onClose={() => setUpdateOpen(false)}
        />
      )}
      <Divider variant="middle" />
    </>
  );
}
